<template>
  <div class="__currency" :class="{ block: block }">
    <span>
      <span :class="{ 'small-symbol': smallSymbol }" v-if="type">{{ symbol }}</span>
      <span>{{ formattedNumber }}</span>
      <q-tooltip :delay="500" anchor="top middle" self="bottom middle">
        {{ value }}
      </q-tooltip>
    </span>
  </div>
</template>

<script>
// TODO: This component is new version of Numbers.vue. Need to replace to this from old one.
/*
    Show currency
    Support: USD, JPY, MYR

    e.g.
    type: 'usd/USD/$'
    12345 -> $12,345.00

    type: 'jpy/JPY/yen'
    12345 -> ¥12,345

    [Memo]
    TODO: Need tooltip

    [Props]
    value（必須） : 。
    type(String) : Currency type. usd / jpy
    small-symbol(Boolean) : Use small symbol.
    precision: ...
    roundingMode: ...

    // Not supported yet
    tooltip(String/Number) : Show tooltip. Bind message.
    placement(String) :Position of tooltip. default: top
      [Accepted values: top/top-start/top-end/bottom/bottom-start/bottom-end/left/left-start/left-end/right/right-start/right-end]
    openDelay(String/Number) : Delay of appearance, in millisecond. default: 500
    */

import BigNumber from 'bignumber.js';
import { currencySymbol, currencyPrecision, currencySeparator } from '@/lib/currency';

export default {
  name: 'Currency',
  props: {
    value: { type: [String, Number] },
    type: { type: String },
    smallSymbol: { type: Boolean, default: false },
    precision: { type: Number },
    roundingMode: { type: Number, default: 1 }, // Reference: BigNumber.js docs. (1: ROUND_DOWN)
    block: { type: Boolean, default: false },
    // Tooltip
    tooltip: [String, Number],
    openDelay: { type: [String, Number], default: 500 },
  },
  computed: {
    formattedNumber() {
      const num = this.value;

      if (num === null || num === undefined) return '-';

      if (isNaN(num)) return '-';

      /**
       * Precision
       */
      // Default precision is 2
      let precision;

      if (this.precision) {
        precision = this.precision;
      } else {
        precision = currencyPrecision(this.type);
      }

      // Format
      const fmt = {
        decimalSeparator: currencySeparator(this.type).decimal,
        groupSeparator: currencySeparator(this.type).group,
        groupSize: 3,
      };

      return new BigNumber(num).toFormat(precision, BigNumber.ROUND_DOWN, fmt);
    },

    symbol() {
      return currencySymbol(this.type);
    },

    content() {
      return String(this.tooltip);
    },

    delay() {
      return Number(this.openDelay);
    },
  },
};
</script>

<style lang="scss" scoped>
.__currency {
  display: inline-block;

  &.block {
    display: block;
  }

  span {
    font-size: 1em;
  }

  .small-symbol {
    font-size: 0.7em;
  }
}
</style>
